import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "header-component"
};
import DxButton from "devextreme-vue/button";
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import DxTagBox from "devextreme-vue/tag-box";
import UserPanel from "./user-panel";
export default {
  __name: 'header-toolbar',
  props: {
    menuToggleEnabled: Boolean,
    title: String,
    toggleMenuFunc: Function,
    logOutFunc: Function
  },
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const securityStore = useSecurityStore();
    const taxiDepotStore = useTaxiDepotStore();
    const {
      user
    } = storeToRefs(securityStore);
    const userType = ref(process.env.VUE_APP_USER_TYPE);
    const userMenuItems = [];
    const availableTaxiDepots = ref(securityStore.taxiDepot);
    const chooseTaxiDepot = ref(securityStore.selectedTaxiDepots.length > 0 ? securityStore.selectedTaxiDepots : securityStore.taxiDepot);
    let defaultFilter = [];
    availableTaxiDepots.value?.forEach(taxiDepotOid => {
      defaultFilter.push(["oid", "=", taxiDepotOid]);
      defaultFilter.push("or");
    });
    onMounted(async () => {
      await taxiDepotStore.getIndex({
        loadOptions: {
          filter: defaultFilter
        }
      });
    });
    watch(() => chooseTaxiDepot.value, () => {
      if (chooseTaxiDepot.value == null) {
        securityStore.setTaxiDepot([]);
      } else {
        securityStore.setTaxiDepot(chooseTaxiDepot.value);
      }
    }, {
      deep: true,
      immediate: true
    });
    if (userType.value == "Manager") {
      userMenuItems.push({
        text: "Profile",
        icon: "user",
        onClick: onProfileClick
      }, {
        text: "Logout",
        icon: "runner",
        onClick: onLogoutClick
      });
    } else {
      userMenuItems.push({
        text: "Logout",
        icon: "runner",
        onClick: onLogoutClick
      });
    }
    function onLogoutClick() {
      securityStore.destroyJwtData();
      router.push({
        path: "/login-form",
        query: {
          redirect: route.path
        }
      });
    }
    function onProfileClick() {
      router.push({
        path: "/profile"
      });
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("header", _hoisted_1, [_createVNode(_unref(DxToolbar), {
        class: "header-toolbar"
      }, {
        menuUserItem: _withCtx(() => [_createVNode(_unref(UserPanel), {
          email: _ctx.email,
          "menu-items": userMenuItems,
          "menu-mode": "list"
        }, null, 8, ["email"])]),
        default: _withCtx(() => [_createVNode(_unref(DxItem), {
          visible: __props.menuToggleEnabled,
          location: "before",
          "css-class": "menu-button"
        }, {
          default: _withCtx(() => [_createVNode(_unref(DxButton), {
            icon: "menu",
            "styling-mode": "text",
            onClick: __props.toggleMenuFunc
          }, null, 8, ["onClick"])]),
          _: 1
        }, 8, ["visible"]), _createVNode(_unref(DxItem), {
          location: "before"
        }, {
          default: _withCtx(() => [_createVNode(_unref(DxTagBox), {
            value: _unref(chooseTaxiDepot),
            "onUpdate:value": _cache[0] || (_cache[0] = $event => _isRef(chooseTaxiDepot) ? chooseTaxiDepot.value = $event : null),
            dataSource: _unref(taxiDepotStore).indexTaxiDepots?.data || [],
            "hide-selected-items": true,
            "search-enabled": true,
            displayExpr: "name",
            valueExpr: "oid",
            height: "56px"
          }, null, 8, ["value", "dataSource"])]),
          _: 1
        }), __props.title ? (_openBlock(), _createBlock(_unref(DxItem), {
          key: 0,
          location: "before",
          "css-class": "header-title dx-toolbar-label"
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(__props.title), 1)]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_unref(DxItem), {
          location: "after",
          "locate-in-menu": "auto",
          "menu-item-template": "menuUserItem"
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_unref(DxButton), {
            class: "user-button authorization",
            width: 210,
            height: "100%",
            "styling-mode": "text"
          }, {
            default: _withCtx(() => [_unref(user)?.usertype === 'Employee' ? (_openBlock(), _createBlock(_unref(UserPanel), {
              key: 0,
              email: _unref(user).email,
              "menu-items": userMenuItems,
              "menu-mode": "context"
            }, null, 8, ["email"])) : (_openBlock(), _createBlock(_unref(UserPanel), {
              key: 1,
              email: `+` + _unref(user)?.phone,
              "menu-items": userMenuItems,
              "menu-mode": "context"
            }, null, 8, ["email"]))]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
};